import React from 'react'

import { Search } from 'lucide-react'

import { useTranslation } from '@/core/i18n/useTranslation'

interface EmptyStateProps {
	hasSearch: boolean
}

const EmptyState: React.FC<EmptyStateProps> = ({ hasSearch }) => {
	const { t } = useTranslation('common')

	return (
		<div className="flex flex-col items-center justify-center py-12 px-4">
			<div className="text-center space-y-4">
				<div className="w-16 h-16 mx-auto bg-muted rounded-full flex items-center justify-center">
					<Search className="w-8 h-8 text-muted-foreground" />
				</div>

				<div className="space-y-2">
					<h3 className="text-lg font-semibold text-foreground">
						{hasSearch
							? t('integrations.empty_state.no_integrations_found')
							: t('integrations.empty_state.no_integrations_available')}
					</h3>
					<p className="text-sm text-muted-foreground max-w-md">
						{hasSearch
							? t('integrations.empty_state.no_integrations_description')
							: t(
									'integrations.empty_state.no_integrations_available_description'
								)}
					</p>
				</div>
			</div>
		</div>
	)
}

export default EmptyState
